import React from 'react';
import { CreditCheckResult } from 'modules/cm/Credit/Credit';
import { Th, Td, TableHead, Table, TableBody } from './CreditHistory.styled';

interface Props {
  history: CreditCheckResult[];
}

const CreditHistory: React.FC<Props> = ({ history }) => {
  return (
    <Table cellSpacing={0}>
      <TableHead>
        <tr>
          <Th>Type</Th>
          <Th>Date</Th>
          <Th>Credit reference</Th>
        </tr>
      </TableHead>
      <TableBody>
        {history.length ? (
          history.map((item, index) => (
            <tr key={item.referenceNumber + index || index}>
              <Td>{item.type}</Td>
              <Td>{item.dateOfSearch}</Td>
              <Td>{item.referenceNumber || '-'}</Td>
            </tr>
          ))
        ) : (
          <tr>
            <Td colSpan={3}>No searches</Td>
          </tr>
        )}
      </TableBody>
    </Table>
  );
};

export default CreditHistory;
